export * from '../src/SeoButton/SeoButton';
export { SeoButton as default } from '../src/SeoButton/SeoButton';
